module.exports = __webpack_public_path__ + "static/media/summary.8691d07d.md";